import styled from 'styled-components';

export default styled.div`
  margin: 50px 0;
`;
